import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Link, useLocation } from "react-router-dom";
import { useResetPassword } from "../../hooks/use-reset-password";
import { ResetForm } from "./reset-form";

const schema = yup
    .object({
        email: yup
            .string()
            .email("Invalid email")
            .required("Email is required"),
    })
    .required();

export const ResetPassword = () => {
    const location = useLocation();

    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const mutation = useResetPassword();

    const onSubmit = (data) => {
        mutation.mutate(data);
    };

    return (
        <div className="w-full">
            <div>
                <h1 className="mb-3 text-3xl/6 font-bold">
                    Restore your password
                </h1>
                <p className="mb-3 text-sm">
                    You will receive an email with a link to reset your password
                </p>
            </div>
            <ResetForm
                methods={methods}
                mutation={mutation}
                onSubmit={onSubmit}
            />
            <div className="mt-3">
                <Link
                    to="/login"
                    state={location.state}
                    className="text-sm no-underline hover:underline"
                >
                    <strong>Back to sign in</strong>
                </Link>
            </div>
        </div>
    );
};
